module.exports = __webpack_public_path__ + "img/18.5cd62539.webp";